import React, { useEffect, useRef, useState } from "react";
import { Item, ComboBox, useAsyncList } from "@adobe/react-spectrum";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { GetContactListRequest } from "../../../../../services/soap/main/requests/GetContactListRequest";
import { useTranslation } from "react-i18next";


export interface Character {
    id:number;
    name1: string;
    name2: string;
    name3: string;
}

interface ICompanyDropDownProps{
   onChange:(data:Character,index:number,mode:string)=> void;
   selectedCompany?:string;
   showLabel?:boolean
}

const CompanyDropDown:React.FC<ICompanyDropDownProps> = ({onChange,selectedCompany,showLabel}) => {
  const { store, mainService } = useDependency();
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const { t } = useTranslation('contacts');
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  const firstInputRef = useRef<any>(null);
  useEffect(()=>{
     list.reload();
     if (firstInputRef.current) {
        firstInputRef.current.focus();
      }
  },[])

  useEffect(() => {
        if (selectedCompany) {
          setSelectedKey(selectedCompany);
          // list.setFilterText(selectedCompany)
          list.reload();
        } else {
          setSelectedKey(null);
        }
      }, [selectedCompany]);

  const list = useAsyncList<Character>({
    async load({ cursor,filterText }) {
      const offset = cursor ? Number(cursor) : 0;
      const limit = 50;
      try {
        const request = new GetContactListRequest(store.Server, store.SessionId, 
          { limit, offset,type: 2,contains:`*${filterText}`});
        const response = await mainService.getContactList(request);

        const companies = response?.CONTACT || [];
        if (!Array.isArray(companies)) {
          console.error("Invalid API response: Expected an array", response);
          return { items: [] };
        }

        return {
          items: companies,
          cursor: companies.length === limit ? String(offset + limit) : undefined,
        };
      } catch (error) {
        console.error("Error fetching companies:", error);
        return { items: [] };
      }
    },
  });
  
  const handleSelectionChange = (key:any) => {
    setSelectedKey(key);
    if (key) {
      const selectedCompany = list.items.find((x) => x.id === key);
      if (selectedCompany) {
        onChange(selectedCompany,0,"add");
      }
    }
  };

  return (
    <ComboBox
      ref={firstInputRef}
      label={showLabel ? _tt("companies"):""}
      items={list.items}
      loadingState={list.loadingState}
      onLoadMore={list.loadMore}
      selectedKey={selectedKey}
      onSelectionChange={handleSelectionChange}
      onInputChange={list.setFilterText}
      width="100%"
    > 
  {(item) => (
    <Item key={item.id} textValue={item.name1}>
        {item.name1}
    </Item>
  )}
</ComboBox>
  );
};

export default CompanyDropDown;
